import React, { useMemo } from 'react';
import { useRouter } from 'next/router';
import { StyledDiv, StyledImg } from 'theme/commonStyled';
import ErrorImage from 'public/images/technical-error.svg';
import Icon from 'components/Common/Icon';
import MuiButton from 'components/Common/MuiButton';
import i18n from 'locales/fa.json';
import { DashboardRoute } from 'routes/dashboard.routes';
import { getCookie } from 'utils/common.util';
import { MarketWatchRoute } from 'routes/watchlist.routes';
import { ShareholdersRoute } from 'routes/shareholders.routes';
import { NavAnalysisRoute } from 'routes/nav.routes';
import { FundamentalAnalysisRoute } from 'routes/fundamental.routes';
import { SpecialPackageRoute } from 'routes/specialPackage.routes';
import { StyledListContainer, StyledProductLink } from './style';
import { LoginRoute } from 'routes/account.routes';
import { ProductsRoute } from 'routes/product.routes';

const Error: React.FC = () => {
  const router = useRouter();
  const hasToken = !!getCookie('pwa_refresh_token');
  const reloadPage = (): number =>
    window.setTimeout(() => window.location.reload(), 500);

  const routes = useMemo(
    () => [
      { name: i18n.search.shareholders, route: ShareholdersRoute() },
      { name: i18n.watchList.tabs.marketWatch, route: MarketWatchRoute() },
      { name: i18n.global.tabs.specialPackage, route: SpecialPackageRoute() },
      { name: i18n.fundamental.title, route: FundamentalAnalysisRoute() },
      { name: i18n.search.nav, route: NavAnalysisRoute(null, null, 'watch') },
    ],
    [],
  );

  return (
    <StyledDiv isCenter flexDirection="column" height="100vh">
      <StyledImg src={ErrorImage} width="85%" />
      <StyledDiv display="flex" justifyContent="center" width="100%">
        <StyledDiv width={300} isCenter flexDirection="column" p={6}>
          <StyledDiv color="ash90" fontSize={4} mt={6}>
            {i18n.errors.msg1}
          </StyledDiv>
          <StyledDiv color="ash80" fontSize={2} mt={2}>
            {i18n.errors.msg2}
          </StyledDiv>
          {router.route === DashboardRoute() ? (
            <>
              <StyledDiv color="ash80" fontSize={2} mt={2}>
                {i18n.errors.msg3}
              </StyledDiv>
              <StyledListContainer>
                {routes.map(({ route, name }) => (
                  <StyledProductLink href={route} key={name}>
                    {name}
                  </StyledProductLink>
                ))}
              </StyledListContainer>
            </>
          ) : (
            <MuiButton
              variant="white"
              px={12}
              icon={
                <Icon name="icon-arrow-right" color="blue60" fontSize={7} />
              }
              mt={12}
              onClick={(): void => {
                window.location.replace(
                  hasToken ? ProductsRoute() : LoginRoute(),
                );
                reloadPage();
              }}
            >
              {i18n.global.button.goToHomePage}
            </MuiButton>
          )}
        </StyledDiv>
      </StyledDiv>
    </StyledDiv>
  );
};
export default Error;
